import React, { useState, useMemo, useEffect } from "react";
import "../approvalMaster/ApprovalMasterList.scss";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSearch } from "../../hooks/useSearch";
import Data from "../../data/data.json";
import { Pagination } from "../../components/common/Pagination";
import Select from "react-select";
import FetchData, { GetOne, UpdateEntry } from "../../providers/dataProvider";
import validation, { validationContact } from "./validation";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const selectMenuPortalTarget =
  typeof document !== "undefined" ? document.body : null;

const levelOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
];
const EditApprovalMaster = () => {

  const { data: user, loading } = FetchData("userprofile");
  const location = useLocation();
  const navigate = useNavigate()
  const { id } = location.state || {};


  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: location?.state?.row?.formName || "Approval Master",
        backTarget: { pathname: "/approval-master" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [location?.state?.row?.formName, location.pathname]);

  const [approvalDetails, setApprovalDetails] = useState(null);
  const [formValues, setFormValues] = useState([]);
  const [formErrors, setFormError] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [approvalMaster, setApprovalMaster] = useState([])

  useEffect(() => {
    if (id) {
      GetOne("approval", { id }, setApprovalDetails);
    }
  }, [id]);

  const HandleFormChange = (selectedOption, actionMeta, levelIndex, approverIndex = null) => {
    setFormValues((prev) => {
      const updated = [...prev];

      if (approverIndex === null) {

        updated[levelIndex].level = selectedOption?.value
          ? selectedOption
          : { value: selectedOption?.label, label: selectedOption?.label };
      } else {

        updated[levelIndex].approvers[approverIndex][actionMeta.name] = selectedOption?.value
          ? selectedOption
          : { value: selectedOption?.label, label: selectedOption?.label };
      }

      return updated;
    });
  };

  const handleCheckboxChange = (e, levelIndex, approverIndex) => {
    const { name, checked } = e.target;
    setFormValues((prev) => {
      const updated = [...prev];
      updated[levelIndex].approvers[approverIndex][name] = checked;
      return updated;
    });
  };

  useEffect(() => {
    if (approvalDetails?.data?.levels?.length) {
      const mappedLevels = approvalDetails.data.levels.map((level) => ({
        level: { value: level.levelNo, label: level.levelNo },
        approvers: level.approvers.map((approver) => ({
          user: { value: approver.approverId, label: approver.approverName },
          notifications: approver.notifyInSystem,
          mail: approver.notifyByEmail,
        })),
      }));

      setFormValues(mappedLevels);
    }
  }, [approvalDetails]);


  const HandleFormSubmit = (e) => {
    e.preventDefault();

    const errors = validation(formValues);
    setFormError(errors);

    const hasErrors = errors.some((levelError) => {
      if (Object.keys(levelError).length > 0) {
        if (levelError.level) return true;

        if (
          levelError.approvers &&
          levelError.approvers.some((a) => Object.keys(a).length > 0)
        ) {
          return true;
        }
      }
      return false;
    });

    if (!hasErrors) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    const submitProduct = async () => {
      if (isSubmit) {
        const hasErrors = formErrors.some((levelError) => {
          if (levelError.level) return true;
          if (
            levelError.approvers &&
            levelError.approvers.some((a) => Object.keys(a).length > 0)
          ) {
            return true;
          }
          return false;
        });

        if (!hasErrors) {

          try {
            const payload = {
              formId: approvalDetails?.data?.formId || 0,
              levels: formValues.map((level, levelIndex) => ({
                id: approvalDetails?.data?.levels?.[levelIndex]?.id || 0,
                levelNo: level.level?.value || 0,
                approvers: level.approvers.map((approver, approverIndex) => ({
                  id:
                    approvalDetails?.data?.levels?.[levelIndex]?.approvers?.[approverIndex]?.id ||
                    0,
                  approverId: approver.user?.value || "",
                  notifyInSystem: approver.notifications || false,
                  notifyByEmail: approver.mail || false,
                })),
              })),
            };

            await UpdateEntry(
              "approval",
              payload,
              setApprovalMaster,
              "Approval updated successfully",
              "Approval update failed"
            );

          } catch (error) {
            showErrorToast(error?.message);
          } finally {
            setIsSubmit(false);
          }
        } else {
          setIsSubmit(false);
        }
      }
    };

    submitProduct();
  }, [isSubmit, formErrors, formValues]);

  useEffect(() => {
    if (approvalMaster?.status === 200) {
      navigate('/approval-master')
    }
  }, [approvalMaster])

  const HandleClose = () => {
    navigate('/approval-master')
  }

  return (
    <div className="container-fluid edit-approval-master-sec">
      {/* <!-- add-new-sec starts --> */}
      <div className="card">
        <div className="card-body">
          <div className="card">
            <div className="card-header">
              <h2>Approval configuration</h2>
            </div>
            <div className="card-body">
              {/* <!-- add-new-sec ends --> */}
              {/* approvals-sec start */}
              <section className="approvals-sec mt-2">
                <div class="row">
                  <div class="col-12">
                    {/* <!-- table-sec starts --> */}
                    <section className="table-sec">
                      <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="table-responsive">
                            <table className="table table-borderless">
                              <thead>
                                <tr>
                                  <th>Levels</th>
                                  <th>User Name</th>
                                  <th className="w-15">Notifications</th>
                                  <th className="w-15">Mail</th>
                                  <th className="text-right"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {formValues.map((level, levelIndex) =>
                                  level.approvers.map((approver, approverIndex) => (
                                    <tr key={`${levelIndex}-${approverIndex}`}>
                                      <td>
                                        <Select
                                          name="level"
                                          value={level.level}
                                          onChange={(opt, meta) => HandleFormChange(opt, meta, levelIndex)}
                                          options={levelOptions}
                                          className="basic-multi-select"
                                          styles={style}
                                          placeholder="Choose"
                                          menuPortalTarget={selectMenuPortalTarget}
                                          menuPosition="fixed"
                                        />
                                        {formErrors[levelIndex]?.level && (
                                          <p className="form-error">{formErrors[levelIndex].level}</p>
                                        )}

                                      </td>
                                      <td>
                                        <Select
                                          name="user"
                                          value={approver.user}
                                          onChange={(opt, meta) => HandleFormChange(opt, meta, levelIndex, approverIndex)}
                                          options={user
                                            ?.filter((item) => item.userType === 1)
                                            .map((u) => ({
                                              value: u.identityId,
                                              label: `${u.firstName} ${u.lastName}`,
                                            })) || []}
                                          className="basic-multi-select"
                                          styles={style}
                                          placeholder="Choose"
                                          menuPortalTarget={selectMenuPortalTarget}
                                          menuPosition="fixed"
                                        />
                                        {formErrors[levelIndex]?.approvers?.[approverIndex]?.user && (
                                          <p className="form-error">
                                            {formErrors[levelIndex].approvers[approverIndex].user}
                                          </p>
                                        )}
                                      </td>
                                      <td className="w-15">
                                        <div class="form-group">

                                          <input
                                            type="checkbox"
                                            name="notifications"
                                            checked={approver.notifications}
                                            onChange={(e) => handleCheckboxChange(e, levelIndex, approverIndex)}
                                          />
                                        </div>
                                      </td>
                                      <td className="w-15">
                                        <div class="form-group">
                                          <input
                                            type="checkbox"
                                            name="mail"
                                            checked={approver.mail}
                                            onChange={(e) => handleCheckboxChange(e, levelIndex, approverIndex)}
                                          />
                                        </div>
                                      </td>

                                      <td className="text-right">
                                        <span>
                                          <i
                                            className="far fa-trash-alt mr-2"
                                            title="Delete"
                                          ></i>
                                        </span>
                                        <span className="d-none">
                                          <i
                                            className="fas fa-plus"
                                            title="Delete"
                                          ></i>
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* <!-- table-sec end --> */}
                  </div>
                </div>
              </section>
              {/* approvals-sec end */}
            </div>
          </div>
            <div className="row mt-4 mb-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="save-btns d-flex justify-content-end">
                  <button className="btn cancel-btn" onClick={HandleClose}>Cancel</button>
                  <button
                    className="btn save-btn"
                    data-toggle="modal"
                    data-target="#saveSuccessModal"
                    onClick={(e) => HandleFormSubmit(e)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default EditApprovalMaster;
